export const sizeFiles = size => size / 1000 >= 1024 ? Math.round((size / 1000000 + Number.EPSILON) * 100) / 100 + " mb" : Math.round((size / 1000 + Number.EPSILON) * 100) / 100 + " kb";

export const getFilenameResponse = response => {
    const headers = response.headers['content-disposition'];
    return headers.substring(headers.indexOf('=') + 1);
}

export const getContentTypeResponse = response => {
    return response.headers['content-type'];
}

export function download(response) {
    const blobUrl = URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = getFilenameResponse(response);

    document.body.appendChild(link);

    link.dispatchEvent(
        new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        })
    );

    document.body.removeChild(link);
}

export const base64ToFile = (base64, fileName) => {
    const arr = base64.split(',');
    const extension = fileName.split('.').pop().toLowerCase();
    let mime = arr[0].match(/:(.*?);/)[1];

    if (extension === 'pdf') mime = 'application/pdf';
    if (['jpg', 'jpeg'].includes(extension)) mime = 'image/jpeg';
    if (extension === 'png') mime = 'image/png';

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
};

export function json(data, filename) {
    const json = JSON.stringify(data, null, 2)
    const blobUrl = URL.createObjectURL(new Blob([json], { type: "application/json" }));

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${filename}_${new Date().getTime()}.json`;

    document.body.appendChild(link);

    link.dispatchEvent(
        new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        })
    );

    document.body.removeChild(link);
}